import { getRequest } from '@/core';
import { trips } from '@/requests';

export default function getTripByIdRequest(id) {
	let url = trips.getByIdPath(id);
	return getRequest(url);
}
